// Modern color themes for the application
export const COLOR_THEMES = [
  {
    name: 'Coastal Blue',
    colors: {
      primary: '#0891B2',
      secondary: '#155E75',
      accent: '#67E8F9',
      background: '#F0FDFF',
      text: '#0F172A'
    }
  },
  {
    name: 'Emerald Forest',
    colors: {
      primary: '#059669',
      secondary: '#047857',
      accent: '#6EE7B7',
      background: '#ECFDF5',
      text: '#064E3B'
    }
  },
  {
    name: 'Coral Sunset',
    colors: {
      primary: '#F43F5E',
      secondary: '#BE123C',
      accent: '#FDA4AF',
      background: '#FFF1F2',
      text: '#881337'
    }
  },
  {
    name: 'Lavender Dream',
    colors: {
      primary: '#8B5CF6',
      secondary: '#6D28D9',
      accent: '#C4B5FD',
      background: '#F5F3FF',
      text: '#4C1D95'
    }
  },
  {
    name: 'Amber Glow',
    colors: {
      primary: '#D97706',
      secondary: '#B45309',
      accent: '#FCD34D',
      background: '#FFFBEB',
      text: '#78350F'
    }
  },
  {
    name: 'Midnight Indigo',
    colors: {
      primary: '#4F46E5',
      secondary: '#3730A3',
      accent: '#A5B4FC',
      background: '#EEF2FF',
      text: '#312E81'
    }
  },
  {
    name: 'Sage Green',
    colors: {
      primary: '#84CC16',
      secondary: '#65A30D',
      accent: '#BEF264',
      background: '#F7FEE7',
      text: '#365314'
    }
  },
  {
    name: 'Berry Smoothie',
    colors: {
      primary: '#DB2777',
      secondary: '#9D174D',
      accent: '#F9A8D4',
      background: '#FDF2F8',
      text: '#831843'
    }
  },
  {
    name: 'Slate Elegance',
    colors: {
      primary: '#475569',
      secondary: '#334155',
      accent: '#94A3B8',
      background: '#F8FAFC',
      text: '#0F172A'
    }
  },
  {
    name: 'Teal Breeze',
    colors: {
      primary: '#0D9488',
      secondary: '#0F766E',
      accent: '#5EEAD4',
      background: '#F0FDFA',
      text: '#134E4A'
    }
  },
  {
    name: 'Autumn Rust',
    colors: {
      primary: '#EA580C',
      secondary: '#C2410C',
      accent: '#FDBA74',
      background: '#FFF7ED',
      text: '#7C2D12'
    }
  },
  {
    name: 'Nordic Frost',
    colors: {
      primary: '#0EA5E9',
      secondary: '#0369A1',
      accent: '#7DD3FC',
      background: '#F0F9FF',
      text: '#075985'
    }
  },
  {
    name: 'Plum Velvet',
    colors: {
      primary: '#A855F7',
      secondary: '#7E22CE',
      accent: '#D8B4FE',
      background: '#FAF5FF',
      text: '#581C87'
    }
  },
  {
    name: 'Modern Mono',
    colors: {
      primary: '#525252',
      secondary: '#404040',
      accent: '#A3A3A3',
      background: '#FAFAFA',
      text: '#171717'
    }
  },
  {
    name: 'Dark Elegance',
    colors: {
      primary: '#6366F1',
      secondary: '#4338CA',
      accent: '#A5B4FC',
      background: '#1E1B4B',
      text: '#E0E7FF'
    }
  }
];
